// @flow
import React from 'react';
import type { EventType } from 'types/Event';
import { getDateFromString, formatHours } from 'utils/dateUtils';
import { Link } from 'react-router-dom';

type Props = {
  event: EventType,
};

const EventListElement = (props: Props) => {
  const { event } = props;
  const startDate = getDateFromString(event.startDate);
  const endDate = getDateFromString(event.endDate);
  const address = `${event.address} ${event.zip} ${event.city}`;

  return (
    <div className="event__content">
      <h2 className="event__title ft-h4">
        <Link to={`/evenements/${event.slug}`} title={`Voir le détail de l'évènement : ${event.title}`}>
          {event.title}
        </Link>
      </h2>
      <p>
        <span className="event__type ft-h6 ft-up">{props.event.label || props.event.tag }</span>
        {!event.all_day && (
          <span className="event__info">
            <i className="icon icon-clock is-inline" />
            {formatHours(startDate)}
            {startDate.getTime() !== endDate.getTime() && ` - ${formatHours(endDate)}`}
          </span>
        )}
        {event.address && (
          <a href={`https://www.google.com/maps/search/${address}`} target="__blank" className="event__info">
            <i className="icon icon-place is-inline" />
            {address}
          </a>
        )}
      </p>
    </div>
  );
};

export default EventListElement;
